import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allDay", "timeFrom", "timeTo"]

  connect() {
    this.toggleTimeFields()
  }

  toggleTimeFields() {
    const isAllDay = this.allDayTarget.checked

    const elements = [this.timeFromTarget, this.timeToTarget]

    elements.forEach(element => {
      element.disabled = isAllDay
      if (element._flatpickr) { element._flatpickr.altInput.disabled = isAllDay }
    })

    if (isAllDay) {
      this.timeFromTarget._flatpickr?.setDate("00:00")
      this.timeToTarget._flatpickr?.setDate("23:59")
    }
  }
}
